import { render, staticRenderFns } from "./ConfirmForget.vue?vue&type=template&id=239d6977&scoped=true"
import script from "./ConfirmForget.vue?vue&type=script&lang=js"
export * from "./ConfirmForget.vue?vue&type=script&lang=js"
import style0 from "./ConfirmForget.vue?vue&type=style&index=0&id=239d6977&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239d6977",
  null
  
)

export default component.exports